export enum ChatIntegrationProviders {
	SLACK = 'SLACK',
	TELEGRAM_BOT = 'TELEGRAM_BOT',
}
